import React from 'react';
import './PrivacyPage.scss';

const PrivacyPage: React.FC = () => {
  return (
    <div className="policy-page privacy-page">
      <div className="policy-page__container">
        <h1 className="policy-page__title">Privacy Policy</h1>
        <p className="policy-page__updated">Last updated: December 30, 2024</p>

        <div className="policy-page__intro">
          <p>
            This Privacy Policy describes how $HTROM (operated by $HTROM.LLC) collects, 
            uses, and discloses your personal information when you visit or make a 
            purchase from our website.
          </p>
        </div>

        <div className="policy-page__content">
          <section className="policy-page__section">
            <h2 className="policy-page__section-title">Information We Collect</h2>
            <p>When you visit our website, we automatically collect:</p>
            <ul className="policy-page__list">
              <li>Web browser and device information</li>
              <li>IP address and time zone</li>
              <li>Cookies and browsing behavior</li>
            </ul>
            <p>When you make a purchase, we collect:</p>
            <ul className="policy-page__list">
              <li>Name and contact information</li>
              <li>Billing and shipping address</li>
              <li>Payment information (processed by third-party providers)</li>
            </ul>
          </section>

          <section className="policy-page__section">
            <h2 className="policy-page__section-title">How We Use Your Information</h2>
            <ul className="policy-page__list">
              <li>Process and fulfill orders</li>
              <li>Communicate regarding your purchase</li>
              <li>Provide customer support</li>
              <li>Screen orders for fraud</li>
              <li>Improve our website</li>
              <li>Send marketing communications (if opted in)</li>
            </ul>
          </section>

          <section className="policy-page__section">
            <h2 className="policy-page__section-title">Sharing Your Information</h2>
            <p>We share your information with:</p>
            <ul className="policy-page__list">
              <li>Shopify (e-commerce platform)</li>
              <li>Payment processors (Stripe, PayPal, Shop Pay)</li>
              <li>Shipping carriers</li>
              <li>Analytics providers</li>
            </ul>
          </section>

          <section className="policy-page__section">
            <h2 className="policy-page__section-title">Cookies</h2>
            <p>
              We use cookies to enable site functionality, remember preferences, 
              analyze traffic, and support advertising. You can control cookies 
              through your browser settings.
            </p>
          </section>

          <section className="policy-page__section">
            <h2 className="policy-page__section-title">Your Rights</h2>
            <p>Depending on your location, you may have the right to:</p>
            <ul className="policy-page__list">
              <li>Access the personal information we hold about you</li>
              <li>Request correction or deletion of your information</li>
              <li>Opt out of marketing communications</li>
            </ul>
          </section>

          <section className="policy-page__section">
            <h2 className="policy-page__section-title">Data Security</h2>
            <p>
              We implement reasonable security measures to protect your personal 
              information. However, no method of transmission over the Internet 
              is 100% secure.
            </p>
          </section>

          <section className="policy-page__section">
            <h2 className="policy-page__section-title">Contact</h2>
            <p>$HTROM.LLC</p>
            <p className="policy-page__contact">
              <a href="mailto:support@shtromstudio.com">support@shtromstudio.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
